exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container-main {\r\n\tbackground-color: white;\r\n}\r\n\r\n.header-1 {\r\n\tpadding: 5px;\r\n\tbackground-color: #3366CC;\r\n}\r\n\r\n.header-2 {\r\n\tpadding: 10px 0;\r\n}\r\n\r\n.img-govco {\r\n\tmargin-left: 45px;\r\n\twidth: 75px;\r\n\theight: 16px !important;\r\n\tpadding: 7px;\r\n}\r\n\r\n.img-dian {\r\n\tmargin-left: 45px;\r\n    height: 80%;\r\n}\r\n\r\n.img-hda {\r\n    margin-right: 45px;\r\n    height: 70%;\r\n}\r\n\r\n.divider {\r\n\tborder: 1px solid #00B4DC;\r\n\twidth: 100%;\r\n}\r\n\r\n.container-components {\r\n\toverflow:auto;\r\n\theight: 93vh;\r\n}\r\n\r\n.breadcrum-submodule {\r\n\tfont-weight: bold;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/whuerfanoh/Documents/VSCode Projects/ng_identidadlogin/webapp/src/app/modules/habilitar-cuenta/components/contenedor/contenedor.component.css
// module id = ../../../../../src/app/modules/habilitar-cuenta/components/contenedor/contenedor.component.css
// module chunks = main